import Element from '../../../Prototype/UI/Element';
import AnimationComponent from '../../../Component/Animation';
import { CrossPromoAssetType } from '../../../Utility/CrossPromo/CrossPromoDriver';
import { tVector2 } from '../../../Utility/ArrayHelper';

export default class CrossPromoImage extends Element {
    public create(params: { imageType: CrossPromoAssetType; cacheKey: string; [key: string]: any }): void {
        const imageSize: tVector2 = CrossPromoAssetDimensions.has(params.imageType)
            ? CrossPromoAssetDimensions.get(params.imageType)
            : [0, 0];

        const scale: number = params.scale || 1;
        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.cacheKey,
                    },
                },
            ],
            ...params,
        });
        this.container.widthMax = imageSize[0] * scale;
        this.container.widthMin = imageSize[0] * scale;
        this.container.heightMax = imageSize[1] * scale;
        this.container.heightMin = imageSize[1] * scale;

        this.addComponent(AnimationComponent);
    }
}

export const CrossPromoAssetDimensions: Map<CrossPromoAssetType, tVector2> = new Map<CrossPromoAssetType, tVector2>([
    [CrossPromoAssetType.ICON, [300, 300]],
    [CrossPromoAssetType.PORTRAIT_IMAGE, [520, 720]],
    [CrossPromoAssetType.LANDSCAPE_IMAGE, [420, 220]],
    [CrossPromoAssetType.SQUARE_IMAGE, [600, 600]],
    [CrossPromoAssetType.VIDEO, [640, 640]],
]);
